import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "flex flex-col gap-2 text-left",
  "data-testid": "document-history"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-textPrimary" }, "Histórico", -1)
const _hoisted_3 = {
  key: 0,
  class: "text-xs text-[#7f7f8e]"
}
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col gap-2 border-l-2 border-[#e8e8ed] pl-3 ml-1"
}
const _hoisted_5 = { class: "text-[12px] font-semibold text-textPrimary" }
const _hoisted_6 = { class: "text-[11px] text-[#52526f]" }
const _hoisted_7 = {
  key: 0,
  class: "text-[11px] text-[#7f7f8e]"
}

import { computed } from 'vue'

import type {
  DocumentHistoryEvent,
  DocumentHistoryKind
} from '@/types/professional-documents.types'

import { HISTORY_KIND_LABEL, formatDateTime, historyAuthorText } from './labels'


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentHistory',
  props: {
    events: {}
  },
  setup(__props: any) {

const props = __props;



/** O backend já manda do mais novo para o mais antigo; reordenar só protege a leitura. */
const sorted = computed(() => [...props.events].sort((a, b) => Date.parse(b.at) - Date.parse(a.at)))

const DOT: Record<DocumentHistoryKind, string> = {
  SUBMITTED: 'bg-primary30',
  APPROVED: 'bg-sucess',
  REJECTED: 'bg-negative',
  EXPIRED: 'bg-alert',
  UNDONE: 'bg-gray-400'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!_ctx.events.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Sem eventos ainda."))
      : (_openBlock(), _createElementBlock("ol", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sorted.value, (event, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: `${event.kind}-${event.at}-${index}`,
              class: "relative",
              "data-testid": "document-history-event"
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["absolute -left-[19px] top-1 w-2.5 h-2.5 rounded-full", DOT[event.kind]]),
                "aria-hidden": "true"
              }, null, 2),
              _createElementVNode("p", _hoisted_5, [
                _createTextVNode(_toDisplayString(_unref(HISTORY_KIND_LABEL)[event.kind]) + " ", 1),
                (event.versionNumber)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("· versão " + _toDisplayString(event.versionNumber), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", _hoisted_6, [
                _createTextVNode(_toDisplayString(_unref(formatDateTime)(event.at)) + " ", 1),
                (_unref(historyAuthorText)(event))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("· " + _toDisplayString(_unref(historyAuthorText)(event)), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              (event.detail)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(event.detail), 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
  ]))
}
}

})